import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
export const TabValidationsKeys = {
  FORM: 'form',
  OPTIONS: 'options',
  PREVIEW: 'test',
  NAVIGATION: 'navigation',
  AUTOMATION: 'automation'
};
export const DefaultValidation = {
  [FieldTypes.PHONE]: {
    MIN_LENGTH: 7,
    MAX_LENGTH: 20
  }
};
export const ValidationKeys = {
  SUBMIT_LABEL: 'submitLabel',
  THANK_YOU_MESSAGE: 'thankYouMessage',
  REDIRECT_PAGE: 'redirectPage',
  EMAIL_NOTIFICATION_ADDRESS: 'emailNotificationAddress',
  FORM_NAME: 'formName',
  NO_FIELDS: 'noFields',
  FIELD_MIN_GREATER_THAN_MAX: 'fieldMinGreaterThanMax',
  FIELD_NAME_DOES_NOT_MATCH_PROPERTY_NAME: 'fieldNameDoesNotMatchPropertyName',
  FIELD_MAX_LESS_THAN_MIN: 'fieldMaxLessThanMin',
  LEGAL_CONSENT: 'legalConsent',
  PAYMENT_LINK: 'paymentLink',
  FALLBACK_ROUTE: 'fallbackRoute',
  CONDITIONAL_ROUTE: 'conditionalRoute',
  ROUTING_FIELD: 'routingField',
  ROUTING_CONDITION: 'routingCondition'
};
export const ValidationType = {
  REQUIRED: 'REQUIRED',
  INVALID: 'INVALID',
  TOO_LONG: 'TOO_LONG',
  EMPTY: 'EMPTY'
};
const getLangKey = path => `editor.validation.${path}`;
export const Validation = {
  [ValidationKeys.SUBMIT_LABEL]: {
    [ValidationType.REQUIRED]: 'editor.form.config.validation.submitTextRequired'
  },
  [ValidationKeys.THANK_YOU_MESSAGE]: {
    [ValidationType.REQUIRED]: getLangKey('thankYouMessageRequired')
  },
  [ValidationKeys.REDIRECT_PAGE]: {
    [ValidationType.REQUIRED]: getLangKey('redirectPageRequired'),
    [ValidationType.INVALID]: getLangKey('redirectPageInvalid')
  },
  [ValidationKeys.EMAIL_NOTIFICATION_ADDRESS]: {
    [ValidationType.INVALID]: getLangKey('emailNotificationAddressInvalid')
  },
  [ValidationKeys.FORM_NAME]: {
    [ValidationType.TOO_LONG]: getLangKey('formName.tooLong'),
    [ValidationType.EMPTY]: getLangKey('formName.empty')
  },
  [ValidationKeys.NO_FIELDS]: {
    [ValidationType.REQUIRED]: 'editor.validation.noFieldsMessagePublish'
  },
  [ValidationKeys.FIELD_MIN_GREATER_THAN_MAX]: {
    [ValidationType.INVALID]: getLangKey('minValue.invalid')
  },
  [ValidationKeys.FIELD_MAX_LESS_THAN_MIN]: {
    [ValidationType.INVALID]: getLangKey('maxValue.invalid')
  },
  [ValidationKeys.FIELD_NAME_DOES_NOT_MATCH_PROPERTY_NAME]: {
    [ValidationType.INVALID]: getLangKey('fieldNameDoesNotMatchPropertyName.invalid')
  },
  [ValidationKeys.LEGAL_CONSENT]: {
    [ValidationType.INVALID]: getLangKey('legalConsent')
  },
  [ValidationKeys.PAYMENT_LINK]: {
    [ValidationType.REQUIRED]: `editor.validation.paymentRequired`
  },
  [ValidationKeys.FALLBACK_ROUTE]: {
    [ValidationType.REQUIRED]: `editor.validation.fallbackRouteRequired`
  },
  [ValidationKeys.CONDITIONAL_ROUTE]: {
    [ValidationType.REQUIRED]: `editor.validation.conditionalRouteRequired`
  },
  [ValidationKeys.ROUTING_FIELD]: {
    [ValidationType.REQUIRED]: `editor.validation.routingFieldRequired`
  },
  [ValidationKeys.ROUTING_CONDITION]: {
    [ValidationType.REQUIRED]: `editor.validation.routingConditionRequired`
  }
};